module.exports = __webpack_public_path__ + "img/news_01.70656678.jpg";